export function formatDate(publishedDate: number | string | Date) {
	return new Date(publishedDate).toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
}
